import React from 'react';
import { Field, Label, Switch as SwitchBase } from '@headlessui/react';
import classNames, { Argument } from 'classnames';

interface SwitchProps {
  checked: boolean;
  disabled?: boolean;
  labelAfter?: boolean;
  onChange: (checked: boolean) => void;
  className?: Argument;
  labelClassName?: Argument;
  'data-testid'?: string;
  size?: 'default' | 'small'
}

const Switch: React.FC<React.PropsWithChildren<SwitchProps>> = ({
  checked, onChange, disabled, labelAfter, children, className, 'data-testid': dataTestId, labelClassName, size,
}) => (
  <Field>
    <div className={classNames('flex items-center', {
      'flex-row-reverse': labelAfter,
    }, className)}
    >
      <SwitchBase
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={classNames(size, 'switch focus:shadow-focus')}
      >
        <span
          data-testid={dataTestId}
          className={checked ? 'kiosk:translate-x-13!' : 'kiosk:translate-x-1'}
        />

      </SwitchBase>
      <Label className={classNames(labelClassName, 'flex items-center text-left ml-2')}>
        <span className="align-middle text-xs [&>a]:text-xs">{children}</span>
      </Label>
    </div>
  </Field>
);

export default Switch;
